import { Injectable } from '@angular/core';
import { HttpClientService } from '../../client/http-client/http-client.service';
import { ProjectRoot } from '../../domain/projects-domain';
import { ApiConstants } from '../../constants/api.constants';
import { map } from 'rxjs';
import { PhaseRoot } from '../../domain/phases-domain';
import { TaskRoot } from '../../domain/tasks-domain';

export interface ProjectTeamMember {
  projectNo: string;
  email: string;
}

export interface ProjectTeamMembersRoot {
  value: ProjectTeamMember[];
}

@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  constructor(private httpClient: HttpClientService) {}

  fetchProjects() {
    return this.httpClient.get<ProjectRoot>(ApiConstants.PROJECT_LIST_API_URL).pipe(map((res) => res));
  }

  fetchPhase() {
    return this.httpClient.get<PhaseRoot>(ApiConstants.PHASE_LIST_API_URL).pipe(map((res) => res));
  }

  fetchTask() {
    return this.httpClient.get<TaskRoot>(ApiConstants.TASK_LIST_API_URL).pipe(map((res) => res));
  }

  fetchProjectTeamMembers(email: string) {
    const url = `${ApiConstants.PROJECT_TEAM_MEMBERS_URL}?$filter=email eq '${email}'`;
    return this.httpClient.get<ProjectTeamMembersRoot>(url);
  }
}
